import permissions from '../../data/permissions';

export default [
    {
        name: "LandedCostList",
        path: "landed-costs",
        component: () => import('../../views/purchase/LandedCostListView.vue'),
        meta: { requiresAuth: true, authorization: permissions.landed_cost.index }
    },
    {
        name: "LandedCostCreate",
        path: "landed-cost",
        component: () => import('../../views/purchase/LandedCostCreateView.vue'),
        meta: { requiresAuth: true, authorization: permissions.landed_cost.create }
    },
    {
        name: "LandedCostDisplay",
        path: "landed-cost/:id",
        component: () => import('../../views/purchase/LandedCostDisplayView.vue'),
        meta: { requiresAuth: true, authorization: permissions.landed_cost.read }
    },
    {
        name: "LandedCostEdit",
        path: "landed-cost/:id/edit",
        component: () => import('../../views/purchase/LandedCostEditView.vue'),
        meta: { requiresAuth: true, authorization: permissions.landed_cost.update }
    }
]